import React, 
    { 
    useState,
    useEffect 
} from 'react';
import { 
    useParams, 
    useHistory, 
    useLocation 
} from 'react-router-dom';
import { useSelector } from 'react-redux';
import CardForm from './CardFrom/CardForm'
import { toast } from 'react-toastify';
import {
    Post 
} from '../../Api/ApiMethods.js';
import { 
    updatePreviousCardUrl,
    getCardDetailById
 } from '../../Routes/ApiRoutes';

export default function EditCard() {
    const history = useHistory();
    const token = useSelector((state) => state.auth.isSignedIn);
    const { pathname } = useLocation();
    const {id} = useParams();
    const [loader, setLoader] = useState(false);
    const [data, setData] = useState({
        "card_id":id,
        "card_number":"",
        "exp_month": '',
        "exp_year": '',
        "cvv":"",
        "name":"",
        "street":"",
        "address":"",
        "city":"",
        "state":"",
        "zip_code":"",
        "toSave":true
    });
    const [btnName, setBtnName] = useState('Update');
    const [tittle, setTittle] = useState('Edit card details');

    useEffect(() => {
        fetchCardDetails();
    }, [])

    const fetchCardDetails = () => {
        setLoader(true);
        let sendData =  {
            "card_id":id
        }
        try {
            Post(getCardDetailById, token, sendData)
            .then(res => {
                console.log(res);
                if(res.status === 200){
                    setData({
                        "card_id":id,
                        "card_number": res.data.card_number,
                        "exp_month": res.data.exp_month,
                        "exp_year": res.data.exp_year,
                        "cvv": res.data.cvv,
                        "name": res.data.name,
                        "street": res.data.street,
                        "address": res.data.address,
                        "city": res.data.city,
                        "state": res.data.state,
                        "zip_code": res.data.zip_code,
                        "toSave":true
                    });
                    setLoader(false);
                }
            })
            .catch(error => {
                toast.error(error.error);
                setLoader(false);
            })
          }catch (error) {
            toast.error(error.error);
            setLoader(false);
        }
    }

    const handleSavetoDB = (sendData) => {
        setLoader(true);
        try {
            Post(updatePreviousCardUrl, token, sendData)
            .then(res => {
                if(res.status === 200){
                    toast.success(res.message);
                    setTimeout(() => {
                        if(pathname === `/profile/cardList/editCard/${id}`){
                            history.push('/profile/cardList');
                        }
                    }, 2100);
                    setLoader(false);
                }
            })
            .catch(error => {
                toast.error(error.error);
                setLoader(false);
            })
          }catch (error) {
            toast.error(error.error);
            setLoader(false);
        }
    }

    return (
        <>
            <CardForm
                editable={true}
                tittle={tittle}
                loader={loader}
                setLoader={setLoader}
                data={data}
                setData={setData}
                saveData={handleSavetoDB}
                btnName={btnName}
            />
        </>
    )
}
